export default "__VITE_ASSET__x_QfV6WT__"